import * as React from 'react'

import ColoradoClientAgreement from './Colorado/ColoradoClientAgreement'
import {  JobMode } from '../../Job'

import ClientAgreementAll from './ClientAgreementAll'
import * as _ from 'lodash'
import { AgreementT, DocumentT, JobT, JobTypeT } from '../../../../../types/Job'

interface ClientAgreementProps {
   
    company: any
    job: JobT
    jobOrigin: JobT
    jobMode: JobMode
    nextDocument(): void
    refreshJob(newJob: JobT): void
    saveJob(): Promise<JobT>
    updateJob(key: string, value: any): void
    updateDocument(key: string, value: any): void
}
export interface ClientAgreementT extends DocumentT {
    state?: string,
    defaultAgreement: AgreementT
    agreement: Array<AgreementT>
}

const ClientAgreement: React.FunctionComponent<ClientAgreementProps> = ({  company, job, jobOrigin, jobMode, nextDocument, refreshJob, saveJob, updateJob, updateDocument }): JSX.Element => {

    const genericClientAgreement = (): JSX.Element => {
        return (
            <div>
                <p>The Parties involved in this contract are 1) {job.client.firstName} {job.client.lastName} (“Client”), 2) [company] (“Company”).</p>
                <ol>
                    <li>Client agrees to pay for the labor provided, a function of the number of workers provided and the time it takes for these workers to complete the project.</li>
                    <li>Client agrees that the rate for [company]’s workers is [hourly_rate_one] for one worker, [hourly_rate_two] for two workers, and [hourly_rate_three] for three workers.</li>
                    <li>Client agrees that there is a [minimum_time] minimum associated with the services.</li>
                    <li>Client agrees that their labor estimate is:<br />Labor Estimate: {job.crew.length} workers @ $rate_hourly /hour * forecast_duration = $XXX.XX</li>
                    <li>Client agrees that the labor estimate is based on the information provided and forecast to [company]’s sales representatives.  If the number of hours the crew works exceeds the forecast duration, Client agrees to pay the full amount due based on Payment Condition 2.  Likewise, if the number of hours the crew works falls short of the estimated duration and exceeds the [minimum_time] minimum mark, Client is required to pay only for the time that it took, not the estimated duration.  <strong>Client agrees to pay the labor rate based on the actual time it takes and not on the initial estimate.</strong></li>
                    {job.jobType == JobTypeT.intrastate_local && <>
                        <li>Client agrees that the truck estimate is:<br />Truck Estimate:  truck_size’ truck @ miles_forecast miles = $XXX.XX</li>
                        <li>Client agrees that the truck estimates are based on the information provided to our sales representatives.  <strong>If the distance that the truck is required to travel diverges from the estimated distance, Client agrees to pay for the truck charges based on actual distance the truck is to travel for solely that project.</strong></li>
                    </>}
                    <li>In the case of a dispute, Client agrees to pay the full amount due to company prior to engaging in the proper artibration process.</li>
                </ol>
            </div>
        )
    }


    const documentByCity = () => {
        switch (job.jobType) {
            case JobTypeT.moving_labor:
                return <ClientAgreementAll
                   
                    updateDocument={updateDocument}
                    company={company}
                    job={job}
                    jobOrigin={jobOrigin}
                    jobMode={jobMode}
                    nextDocument={nextDocument}
                    refreshJob={refreshJob}
                    saveJob={saveJob}
                    updateJob={updateJob}
                />
            case JobTypeT.intrastate_local:
            case JobTypeT.intrastate_long:
                const addressState = _.isArray(job.locations) && job.locations[0] && job.locations[0].addressState
                switch (addressState) {
                    case 'Colorado':
                        return <ColoradoClientAgreement
                           
                            updateDocument={updateDocument}
                            company={company}
                            job={job}
                            jobOrigin={jobOrigin}
                            jobMode={jobMode}
                            nextDocument={nextDocument}
                            refreshJob={refreshJob}
                            saveJob={saveJob}
                            updateJob={updateJob} />
                    default:
                        return genericClientAgreement()
                }
            default:
                return genericClientAgreement()
        }
    }

    return (
        <>
            {documentByCity()}
        </>
    )
}

export default ClientAgreement